import { render, staticRenderFns } from "./featured_post.vue?vue&type=template&id=6e18ef24&scoped=true&"
import script from "./featured_post.vue?vue&type=script&lang=js&"
export * from "./featured_post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e18ef24",
  null
  
)

export default component.exports